
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/cookie-notice",
      function () {
        return require("private-next-pages/legal/cookie-notice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/cookie-notice"])
      });
    }
  